export default {
	meta: {
		title: 'Désinscription de l’expérience patient',
		description: 'Désinscription de l’expérience patient'
	}
};
